import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

import MuteOnSvg from "@/assets/svg/MuteOn.svg?component";
import MuteOffSvg from "@/assets/svg/MuteOff.svg?component";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OfficeMuteButton',
  props: {
  isMuted: {
    type: Boolean,
    default: false
  }
},
  emits: ["click"],
  setup(__props, { emit }) {

const props = __props;




const textColor = computed(() =>
  props.isMuted ? "text-gray-05" : "text-main"
);
const text = computed(() => (props.isMuted ? "ミュート済" : "ミュート"));

function onClickMuteButton(event: Event) {
  event.preventDefault();
  event.stopPropagation();
  emit("click");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "mute-button",
    onClick: onClickMuteButton
  }, [
    (props.isMuted)
      ? (_openBlock(), _createBlock(_unref(MuteOnSvg), { key: 0 }))
      : (_openBlock(), _createBlock(_unref(MuteOffSvg), { key: 1 })),
    _createTextVNode(),
    _createElementVNode("span", {
      class: _normalizeClass(["text-size-14", textColor.value])
    }, _toDisplayString(text.value), 3)
  ]))
}
}

})